export const GETLANGUAGES = "GETLANGUAGES";
export const SETLANGUAGE = "SETLANGUAGE";
